import { Tab as CollabTab, TabProps } from '@collab/molecules';

const Tab: React.FC<TabProps> = ({ ...props }) => (
  <CollabTab paddedContent {...props} />
);

export default Tab;
